import { FaIcon } from '@/lib/fa'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import * as React from 'react'
import { TooltipOptional } from '../elements/TooltipOptional'
import clx from 'classnames'
import styles from '../styles.module.scss'

type SegmentGroupProps = {
  children: React.ReactNode
  className?: string
  ariaLabel?: string
}

export function SegmentGroup({
  children,
  className,
  ariaLabel,
}: SegmentGroupProps) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className={clx(styles.segmentGroup, className)}
      //   className={[
      //     'tw-flex--center tw-gap-2 tw-inline-flex tw-rounded-xl tw-bg-[#6B77A04D]',
      //     className ?? '',
      //   ].join(' ')}
    >
      {children}
    </div>
  )
}

type SegmentButtonProps = {
  checked: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  className?: string
  name?: string
  value?: string

  /** Accessible label for icon-only buttons */
  ariaLabel?: string
  tooltip?: string

  /** Icon (SVG / component) */
  icon?: IconDefinition
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
}

export function SegmentButton({
  checked,
  onClick,
  disabled,
  className,
  ariaLabel,
  icon,
  Icon,
  tooltip,
  name,
  value,
}: SegmentButtonProps) {
  return (
    <TooltipOptional tooltip={tooltip} portal zIndex={300}>
      <button
        type="button"
        role="button"
        aria-label={ariaLabel}
        aria-pressed={checked}
        disabled={disabled}
        onClick={onClick}
        className={clx(styles.segmentBtn, {
          [styles.checked]: checked,
        })}
        name={name}
        value={value}
        // className={[
        //   'tw-flex--center tw-p-1',
        //   'tw-h-5 tw-w-5 tw-rounded-sm',
        //   'tw-transition tw-duration-150',
        //   'tw-rounded-xl',
        // //   disabled
        // //     ? 'tw-cursor-not-allowed tw-opacity-50'
        // //     : 'tw-active:tw-scale-95',
        //   checked
        //     ? 'tw-bg-content-secondary tw-text-white tw-shadow-md'
        //     : 'tw-text-white tw-opacity-70 hover:tw-bg-slate-300 hover:tw-opacity-100',
        //   className ?? '',
        // ].join(' ')}
      >
        {icon && (
          <FaIcon
            icon={icon}
            className="tw-inline-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center"
          />
        )}
        {Icon && (
          <Icon className="tw-inline-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center" />
        )}
      </button>
    </TooltipOptional>
  )
}
